import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';

import { MatterService } from '../../../services/matters/matter.service';

@Component({
  selector: 'app-matter-billing-summary',
  templateUrl: './matter-billing-summary.component.html',
  styleUrls: ['./matter-billing-summary.component.css'],
})
export class MatterBillingSummaryComponent implements OnInit, OnChanges {
  @Input() matter_id: number;

  billing_summary: any;

  billing_summary_loading: boolean = true;

  constructor(private matterService: MatterService) {}

  // Component lifecycle events
  ngOnInit() {
    this.loadBillingSummary();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.matter_id && changes.matter_id.currentValue) this.loadBillingSummary();
  }

  // Component methods
  loadBillingSummary() {
    this.matterService.getBillingSummary(this.matter_id).then((response_json) => {
      this.billing_summary = response_json;
      this.billing_summary_loading = false;
    });
  }
}
